export type TrackLogEntry = {
  name: string
  props?: unknown
  time: number
  url: string
}

export type TrackLogInput = Omit<TrackLogEntry, 'time'>

/**
 * Called by the Mixpanel mocks from `track`. Under Cypress, `commands.tracking.ts` gives every new window a
 * `__trackLog` function that appends to a log kept outside the window, so events survive a page load. The Cypress
 * side stamps `time`, because `cy.clock` can freeze the app window's clock.
 */
export const forwardTrackToCypressLog = (name: string, props?: unknown): void => {
  const sink = (globalThis as { __trackLog?: (entry: TrackLogInput) => void }).__trackLog
  sink?.({ name, props, url: globalThis.location?.href ?? '' })
}
